import Login from './Login';
import './Login.scss';

export default Login
